export const UNSUPPORTED = {code:-1, label:"UNSUPPORTED"};
export const UNKNOWN = {code:0, label:"UNKNOWN"};
export const GPRS = {code:1, label:"GPRS"};
export const EDGE = {code:2, label:"EDGE"};
export const UMTS = {code:3, label:"UMTS"};
export const CDMA = {code:4, label:"CDMA"};
export const EVDO_0 = {code:5, label:"EVDO 0"};
export const EVDO_A = {code:6, label:"EVDO A"};
export const C1XRTT = {code:7, label:"1XRTT"};
export const HSDPA = {code:8, label:"HSDPA"};
export const HSUPA = {code:9, label:"HSUPA"};
export const HSPA = {code:10, label:"HSPA"};
export const IDEN = {code:11, label:"IDEN"};
export const EVDO_B = {code:12, label:"EVDO B"};
export const LTE = {code:13, label:"LTE"};
export const EHRPD = {code:14, label:"EHRPD"};
export const HSPAP = {code:15, label:"HSPAP"};
export const GSM = {code:16, label:"GSM"};
export const DUAL_CARRIER = {code:30, label:"DUAL_CARRIER"};
export const WIFI = {code:100, label:"WIFI"};
export const GSM_RAT = {code:101, label:"GSM_RAT"};
export const TYPE_2G = {code:103, label:"2G"};
export const TYPE_3G = {code:104, label:"3G"};
export const TYPE_4G = {code:105, label:"4G"};
export const IWLAN = {code:18, label:"IWLAN"};
export const LTE_A = {code:31, label:"LTE A"};



// WEBPACK FOOTER //
// ./js/core/gateway/service/modules/kpi/converter/enums/BearerEnum.js